export const URL_PARAM_CUSTOMER_ID = 'cid'
export const URL_PARAM_ORDER_STATUS = 'status'
export const URL_PARAM_START_DATE = 'sdateneeded'
export const URL_PARAM_END_DATE = 'edateneeded'
